import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { RootState, useAppDispatch } from "../../../../redux/store"
import { LogisticaTiposFormaPago, BigDecimal, LogisticaGuiaEstado } from "@pcgerente-node/pcg-comun"
import Loading from "../../../helpers/Loading/Loading"
import ModalImagenes from "../../../helpers/Modals/ModalImagenes"
import Mapa from "../../../helpers/GoogleMaps/Mapa"
import { buscarGuiaPorNumero } from "../../../../redux/actions/actionsConsulta"
import "../../../../styles/detalles.css"
import { logisticaRangoSeguroViewModel } from "../../../../ViewModels/logisticaRANGO_SEGUROviewModel"
import BannerEstadosGuias from "./BannerEstadosGuia"

const StyleProps1: React.CSSProperties = {
    width: "100%"
}

const StyleProps2: React.CSSProperties = {
    backgroundColor:"#ff5500"
}

const colorWhite: React.CSSProperties = {
    color: "white"
}

const StyleProps4: React.CSSProperties = {
    backgroundColor:"#ff5500",
    color: "white"
}

const StyleProps5: React.CSSProperties = {
    backgroundColor:"#304ACA",
    color:"white"
}

const StyleProps6: React.CSSProperties = {
    backgroundColor:"lightgrey",
    color:"black"
}

const StyleProps7: React.CSSProperties = {
    backgroundColor:"#ff5500",
    minWidth: "220px",
    color: "white"
}

const StyleProps8: React.CSSProperties = {
    backgroundColor:"lightgrey",
    // color:"white"
    color:"black",
}
const StyleProps9 : React.CSSProperties={
    backgroundColor:"#304ACA",
    borderRadius: "1%",
    border: "3px",
    color: "#d9d9f3",
}

const StyleProps10 : React.CSSProperties = {
    border:"1px solid white"
}

const StyleProps11 : React.CSSProperties = {
    border:"1px solid white",
    borderCollapse: "separate",
    color: "white"
}

const DetalleContent = () => {
    const dispatch = useAppDispatch() 
    const { numeroGuia } = useParams()
    const infoRedux = useSelector((state: RootState) => state.consulta.guiaConDetalles);
    const guia = infoRedux.info
   
    useEffect(() => {
        if(numeroGuia){
            const consGuia = numeroGuia.split("-")
            dispatch(buscarGuiaPorNumero(consGuia[0], consGuia[1],Number(consGuia[2])))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        !infoRedux?.loading?
            guia.id && guia.id>0?
                <div id="content" className="main-content">
                    <div className="layout-px-spacing">
                        <div className="row layout-px-spacing">
                            <div id="imagen-fondo">
                                <div className="text-center">
                                    <table style={StyleProps1}>
                                        <tbody>
                                            <tr>
                                                <th style={StyleProps2}><h4 style={colorWhite}>Estado:</h4></th>
                                                <td style={StyleProps2}>
                                                    <h4 style={colorWhite}>
                                                        {guia.estado === LogisticaGuiaEstado.Planta? "En Planta"
                                                            :guia.estado === LogisticaGuiaEstado.Viaje? "Enviado"
                                                            :guia.estado === LogisticaGuiaEstado.RecibidoEnBodegaTransito? "En Bodega"
                                                            :guia.estado === LogisticaGuiaEstado.Ruta? "En ruta"
                                                            :guia.estado === LogisticaGuiaEstado.Entregada? "Entregado"
                                                            :guia.estado === LogisticaGuiaEstado.Anulado ? "Anulado"
                                                            :guia.estado === LogisticaGuiaEstado.Recibido? "Recibido"
                                                            :guia.estado === LogisticaGuiaEstado.Devuelta? "Devuelta"
                                                            :"??"
                                                        }
                                                    </h4>
                                                    
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="tabla-estilos detallles-content-estilos">

                                            <table style={StyleProps1}>
                                                <tbody>

                                                    <tr>
                                                        <th style={StyleProps4}>Guía #:</th>
                                                        <td style={StyleProps7}>{`${guia.serie1}-${guia.serie2}-${guia.numeroDocumento}`}</td>

                                                    </tr>
                                                    <tr>
                                                        <th style={StyleProps5}>Remitente:</th>
                                                        <td style={StyleProps6}>{guia.CLIENTE_REMITENTE?.razonSocial} </td>

                                                    </tr>
                                                    <tr>
                                                        <th style={StyleProps5} scope="row">Destinatario:</th>
                                                        <td style={StyleProps6}>{guia.CLIENTE_DESTINATARIO?.razonSocial}</td>

                                                    </tr>
                                                    <tr>
                                                        <th style={StyleProps5} scope="row">Emisión:</th>
                                                        <td style={StyleProps6}>{new Date(guia.fechaEmision).toLocaleDateString()}</td>

                                                    </tr>

                                                    <tr>
                                                        <th style={StyleProps5} scope="row">Origen:</th>
                                                        <td style={StyleProps6}>{guia.CIUDAD_ORIGEN?.nombre} </td>

                                                    </tr>
                                                    <tr>
                                                        <th style={StyleProps5} scope="row">Destino:</th>
                                                        <td style={StyleProps6}>{guia.CIUDAD_DESTINO?.nombre} </td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>


                                    <div className="col-sm-6">
                                        <div className="tabla-estilos detallles-content-estilos">

                                            <table style={StyleProps1}>
                                                <tbody>
                                                    <tr>
                                                        <th style={StyleProps4}>Urgente:</th>
                                                        <td style={StyleProps7}>{guia?.entregaUrgente ? "SI" : "NO"}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={StyleProps5}>Tipo:</th>
                                                        {guia?.tipo?
                                                            <td style={StyleProps6}>{
                                                                guia.tipo === LogisticaTiposFormaPago.Credito ? "Credito"
                                                                : guia.tipo  === LogisticaTiposFormaPago.Contado ? "Contado"
                                                                : guia.tipo  === LogisticaTiposFormaPago.FleteCobro ? "Flete Cobro"
                                                                : guia.tipo  === LogisticaTiposFormaPago.Todos ? "Todos"
                                                                : ""
                                                            }
                                                            </td>
                                                            : <></>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <th style={StyleProps5} scope="row">Seguro:</th>
                                                        <td style={StyleProps6}>{
                                                        new BigDecimal(guia.seguro).greaterThan(0)?
                                                            `$${new BigDecimal(guia.seguro).toFixed(2)} ${logisticaRangoSeguroViewModel.ObtenerRangoSeguroAplicadoFromGuia("existe", guia)? 
                                                                `(porcentaje aplicado: ${logisticaRangoSeguroViewModel.ObtenerRangoSeguroAplicadoFromGuia("porcentaje", guia)}%)`
                                                                : ""}` 
                                                            : "NO"
                                                        }</td>

                                                    </tr>
                                                    <tr>
                                                        <th style={StyleProps5} scope="row">Seguro Pagado:</th>
                                                        <td style={StyleProps6}>{guia.seguroPagado? "SI" : "NO"}</td>

                                                    </tr>

                                                    <tr>
                                                        <th style={StyleProps5} scope="row">Observación</th>
                                                        <td style={StyleProps6}>{guia.observacion} </td>

                                                    </tr>
                                                    <tr>
                                                        <th style={StyleProps5} scope="row">Total:</th>
                                                        <td style={StyleProps6}>${new BigDecimal(guia.total).toString()}</td>

                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <BannerEstadosGuias estadoGuia={guia.estado}/>
                                <div>
                                    <p ></p>
                                    <p ></p>
                                    <p ></p>
                                </div>
                                {
                                    guia.idMotivoDevolucion?
                                    <div className="inv--product-table-section">
                                    <div className="table-responsive detallles-content-estilos">
                                        <table className="table border=solid 5px" style={StyleProps10}>
                                            <thead className="">
                                                <tr style={StyleProps9}>
                                                    <th style={colorWhite}>Fecha de Entrega</th>
                                                    <th style={colorWhite}>Motivo de Devolución</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table border=solid 5px" style={StyleProps11} >
                                                <tr>
                                                    <td style={StyleProps8} className="text-left">{guia.fechaEntrega?new Date(guia.fechaEntrega).toLocaleDateString(): ""}</td>
                                                    <td style={StyleProps8} className="text-left ">{guia.logistica_MOTIVO_DEVOLUCION? guia.logistica_MOTIVO_DEVOLUCION.descripcion: "NO ESPECÍFICADO"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                    :
                                <div className="inv--product-table-section">
                                    <div className="table-responsive detallles-content-estilos">
                                        <table className="table border=solid 5px" style={StyleProps10}>
                                            <thead className="">
                                                <tr style={StyleProps9}>
                                                    <th style={colorWhite}>Fecha de Entrega</th>
                                                    <th style={colorWhite}>Recibido por</th>
                                                    <th style={colorWhite}>Observación Entrega</th>
                                                    <th style={colorWhite}>Historial</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table border=solid 5px" style={StyleProps11} >
                                                <tr>
                                                    <td style={StyleProps8} className="text-left">{guia.fechaEntrega?new Date(guia.fechaEntrega).toLocaleDateString(): ""}</td>
                                                    <td style={StyleProps8} className="text-left">{guia.personaEntrega}</td>
                                                    <td style={StyleProps8} className="text-left">{guia.novedadesEntrega}</td>
                                                    <td style={StyleProps8} className="text-left">  {guia.logistica_GUIA_GESTION?.map(item => (
                                                        <React.Fragment key={item.id}>
                                                            - {item.fechaCreacion.toString().slice(0,10)} {item.fechaCreacion.toString().slice(11,19)}
                                                            <ul>
                                                                <li>  {item.descripcion}</li>
                                                            </ul>
                                                        </React.Fragment>
                                                    ))}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                }


                                <div className="col-sm-12 text-center" id="contenedor-imagenes-carrusel-detalles">
                                    {guia?.logistica_GUIA_FOTOS?
                                    <ModalImagenes
                                    fotos={guia.logistica_GUIA_FOTOS}
                                    />
                                    :<></>
                                }
                                </div>
                                {guia.longitud && guia.latitud? 
                                <div className="d-flex justify-content-center mt-4 mb-5">
                                    <Mapa
                                        latitud={guia.latitud.toString()}
                                        longitud={guia.longitud.toString()}
                                    />
                                </div>
                                :<></>
                                }
                            </div>
                            <div className="table-responsive detallles-content-estilos">



                            {guia.logistica_GUIA_GESTION && guia.logistica_GUIA_GESTION?.length>0?
                            <table className="table border=solid 5px" style={StyleProps10}>
                                            <thead className="">
                                                <tr style={StyleProps9}>
                                                    <th style={colorWhite}>Fecha </th>
                                                    <th style={colorWhite}>Descripción</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table border=solid 5px" style={StyleProps11} >
                                                {guia.logistica_GUIA_GESTION.map(el =>{
                                                    return(
                                                    <tr>
                                                        <td style={StyleProps8} >{el.fechaCreacion?new Date(el.fechaCreacion).toLocaleString(): ""}</td>
                                                        <td style={StyleProps8} >{el.descripcion}</td>
                                                    </tr>
                                                        )
                                                } )}
                                            </tbody>
                                        </table>
                                        :<></>
                            }
                            </div>


                        </div>
                    </div>
                </div>

            :
            <div id="content" className="main-content d-flex justify-content-center">
            {infoRedux.errorUndefined?
                <span className="mt-5 text-danger">{infoRedux.errorUndefined}</span>
                :<></>
            }
            </div>
        :
        <div id="content" className="main-content">
            <Loading />
        </div>

    )

}


export default DetalleContent